export const MULTIPIN_RECORDS_PAGE_SIZE = 50;
